<div
    [id]="id + '.' + filter.id"
    class="agpr-engagementFilter"
>
    <agpr-scroll-panel class="agpr-engagementFilter-scrollPanel">
        @for (key of engagementFilterKeys; track key) {
            @let engagementValue = value[key];
            <div class="engagementSection">
                <div class="agpr-engagementFilter-headingRow">
                    @let heading = 'Social.filter.engagements.' + (key === 'engagementTotal' ? 'total' : key);
                    @let tooltip = tooltips[key];

                    <h4 class="agpr-engagementFilter-heading">{{ heading | localize }}</h4>
                    @if (tooltip) {
                        <span
                            role="img"
                            class="fa-regular fa-circle-info"
                            [agprTooltip]="tooltip"
                            [tooltipPosition]="'top'"
                        ></span>
                    }
                </div>
                <div class="agpr-engagementFilter-minMaxRow">
                    <agpr-number-input
                        [id]="id + '.totalEngagements.min'"
                        class="social"
                        [label]="'Social.filter.engagements.minimum'"
                        [min]="engagementMinimum"
                        [max]="engagementValue.max ? engagementValue.max - 1: (engagementMaximum - 1)"
                        [integerOnly]="true"
                        [forceMinValue]="false"
                        [(ngModel)]="engagementValue.min"
                        (ngModelChange)="update()"
                    ></agpr-number-input>
                    <agpr-number-input
                        [id]="id + '.totalEngagements.max'"
                        class="social"
                        [label]="'Social.filter.engagements.maximum'"
                        [min]="engagementValue.min ? engagementValue.min + 1 : (engagementMinimum + 1)"
                        [max]="engagementMaximum"
                        [integerOnly]="true"
                        [forceMinValue]="false"
                        [(ngModel)]="engagementValue.max"
                        (ngModelChange)="update()"
                    ></agpr-number-input>
                </div>
            </div>
        }

        <!-- @TODO NEP-11189
        <h4 class="agpr-engagementFilter-heading">{{ 'Social.filter.engagements.byType' | localize }}</h4>
        <div class="engagementType">
            <ng-container *ngFor="let network of value.networkTypes">
                <div class="engagementTypeRow">
                    <a
                        class="engagementType--button fa-solid"
                        (click)="network.expanded = !network.expanded"
                        role="button"
                        [attr.aria-expanded]="network.expanded"
                        [class]="network.expanded ? 'fa-angle-down' : 'fa-angle-right'"
                    ></a>
                    <span class="engagementType-h3">
                        {{ network.label | localize }}
                    </span>
                </div>
                <div
                    *ngIf="network.expanded"
                    class="engagementTypeList"
                >
                    <ng-container *ngFor="let engageType of network.engagementTypes">
                        <div class="engagementTypeSubRow">
                            <a
                                class="engagementType--button fa-solid"
                                (click)="engageType.expanded = !engageType.expanded"
                                role="button"
                                [attr.aria-expanded]="engageType.expanded"
                                [class]="engageType.expanded ? 'fa-angle-down' : 'fa-angle-right'"
                            ></a>
                            <span class="engagementType-h4">
                                {{ engageType.label | localize }}
                            </span>
                        </div>
                        <div
                            *ngIf="engageType.expanded"
                            class="engagementType-minMaxRow"
                        >
                            <agpr-number-input
                                [id]="id + '.typeEngagements' + engageType.label + '.min'"
                                class="social"
                                [label]="'Social.filter.engagements.minimum'"
                                [min]="engagementMinimum"
                                [max]="engageType.range.max ? engageType.range.max - 1: (engagementMaximum - 1)"
                                [integerOnly]="true"
                                [(ngModel)]="engageType.range.min"
                                [forceMinValue]="false"
                                (ngModelChange)="update()"
                            ></agpr-number-input>
                            <agpr-number-input
                                [id]="id + '.typeEngagements' + engageType.label + '.max'"
                                class="social"
                                [label]="'Social.filter.engagements.maximum'"
                                [min]="engageType.range?.min ? engageType.range.min + 1 : (engagementMinimum + 1)"
                                [max]="engagementMaximum"
                                [integerOnly]="true"
                                [forceMinValue]="false"
                                [(ngModel)]="engageType.range.max"
                                (ngModelChange)="update()"
                            ></agpr-number-input>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div> -->
    </agpr-scroll-panel>
</div>
